document.addEventListener('DOMContentLoaded', () => {
  // Get references to Load More button and container that holds the items
  const loadMoreBtn = document.getElementById('zb-load-more-btn');
  const itemsContainer = document.getElementById('zb-load-more-items-container');

  // Exit if either button or container doesn't exist
  if (!loadMoreBtn || !itemsContainer) return;

  loadMoreBtn.addEventListener('click', async () => {
    // Get the next page URL from the button's data attribute
    const nextUrl = loadMoreBtn.dataset.nextUrl;
    if (!nextUrl) return;

    // Show loading state in UI
    loadMoreBtn.disabled = true;
    const originalText = loadMoreBtn.textContent;
    loadMoreBtn.textContent = 'Loading...';

    try {
      // Fetch the next page HTML using AJAX
      const response = await fetch(nextUrl, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });

      if (!response.ok) throw new Error('Failed to fetch next page');

      const htmlText = await response.text();

      // Parse the fetched HTML response into a DOM
      const doc = new DOMParser().parseFromString(htmlText, 'text/html');

      // Select new items using the same container and item class from the response
      const newItems = doc.querySelectorAll('#zb-load-more-items-container .zb-load-more-item');

      // If no new items found, remove button and stop
      if (newItems.length === 0) {
        loadMoreBtn.remove();
        return;
      }

      // Append new items using a DocumentFragment for performance
      const fragment = document.createDocumentFragment();
      newItems.forEach(item => fragment.appendChild(item));
      itemsContainer.appendChild(fragment);

      // Find the Load More button in the fetched HTML to get the next page URL
      const nextPageBtn = doc.querySelector('#zb-load-more-btn');
      const newNextUrl = nextPageBtn?.dataset.nextUrl;

      if (newNextUrl) {
        // Update button with the new next URL
        loadMoreBtn.dataset.nextUrl = newNextUrl;
        loadMoreBtn.disabled = false;
        loadMoreBtn.textContent = originalText;
      } else {
        // No more pages — remove the button
        loadMoreBtn.remove();
      }

    } catch (error) {
      // Handle error case: show error, reset button
      console.error('Load More Error:', error);
      loadMoreBtn.disabled = false;
      loadMoreBtn.textContent = originalText;
      alert('Could not load more items. Please try again later.');
    }
  });
});
